import React from 'react';
import { Button, Spinner, Typography } from '@telus-uds/components-web';
import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import {
  StatusBarWrapper,
  BoxWrapper,
  DueMonthlyWrapper,
  LabelDueMonthly,
  PricingBlockMain,
  BeforeTaxesLabel,
  DueNowWrapper,
  IntegralPart
} from './css';
import { formatCurrency } from '../../utils/currencyFormatter';

const getFormattedPricing = price => {
  return <IntegralPart>{formatCurrency(price)}</IntegralPart>;
};

const FmSOWStatusBar = ({
  step,
  isLastStep,
  isFormTouched,
  onSaveAndExit,
  onProceedClick,
  onBackClick,
  totalMonthly,
  totalOneTime,
  onQuoteDownload,
  quotePdfStatus
}) => {
  const localizedStrings = useLocalizedStringsContext();
  isFormTouched = true;
  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      saveContinueLaterButtonLabel,
      submitButtonLabel
    }
  } = localizedStrings;

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <>
            <DueMonthlyWrapper>
              <div>
                <LabelDueMonthly>Due Monthly</LabelDueMonthly>
                <PricingBlockMain>
                  {getFormattedPricing(totalMonthly)}
                </PricingBlockMain>
                <BeforeTaxesLabel>Before Taxes</BeforeTaxesLabel>
              </div>
            </DueMonthlyWrapper>
            <DueNowWrapper>
              <>
                <div>
                  <LabelDueMonthly>Due Now</LabelDueMonthly>
                  <PricingBlockMain>
                    {getFormattedPricing(totalOneTime)}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>Before Taxes</BeforeTaxesLabel>
                </div>
              </>
            </DueNowWrapper>
          </>
          <>
            {step !== 1 && (
              <Button variant={{ priority: 'high' }} type="button"
                onClick={onBackClick}>
                {backLabel}
              </Button>
            )}
            <Button
              type="button"
              onClick={e => onSaveAndExit(e)}
              variant={{ priority: 'high' }}
              disabled={!isFormTouched}
            >
              {saveContinueLaterButtonLabel}
            </Button>
            {
              isLastStep && (
                <>
                  <Spinner label="Preparing PDF…" variant={{ size: 'small' }} show={quotePdfStatus === 'PREPARING'} inline>
                    <Button
                      type="button"
                      disabled={quotePdfStatus === 'PREPARING'}
                      onClick={() => {
                        onQuoteDownload();
                      }}
                      variant={{ priority: 'high' }}
                    >
                      Download SOW PDF
                    </Button>
                  </Spinner>
                  {quotePdfStatus === 'FAILED' && (
                    <Typography variant={{ colour: 'error' }}>Download failed — please try again.</Typography>
                  )}
                </>
              )
            }
            <Button
              type="button"
              onClick={e => onProceedClick(e)}
              variant={{ priority: 'high' }}
            >
              {isLastStep ? submitButtonLabel : continueButtonLabel}
            </Button>
          </>
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};

FmSOWStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  totalMonthly: PropTypes.number.isRequired,
  totalOneTime: PropTypes.number.isRequired,
  quotePdfStatus: PropTypes.string
};

export default FmSOWStatusBar;
